<template>
  <v-card>
    <v-card-title class="pa-0">
      <v-toolbar color="#f5f5f559" flat>
        <v-toolbar-title>My Stock List</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-row justify="end" no-gutters>
          <v-col cols="12" sm="10" xl="8">
            <v-text-field
              placeholder="search"
              color="primary"
              append-icon="mdi-magnify"
              dense
              outlined
              hide-details
              class="screener-input"
              v-model.trim="query"
              clearable
              @input="search(query)"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-toolbar>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="filter-res pa-0">
      <v-subheader v-if="showSelected">
        SELECTED STOCKS
        <v-spacer></v-spacer>
        <v-btn
          text
          small
          color="primary"
          class="font-weight-bold"
          @click="showSelected = !showSelected"
        >
          View Search Results
        </v-btn>
      </v-subheader>
      <v-subheader v-else>
        SEARCH RESULTS
        <v-spacer></v-spacer>
        <v-btn
          text
          small
          color="primary"
          class="font-weight-bold"
          @click="showSelected = !showSelected"
          :disabled="selectedItems.length === 0"
        >
          View Selected ({{ selectedCount }})
        </v-btn>
      </v-subheader>
      <v-divider></v-divider>
      <div class="pt-4 text-center" v-if="searchResults.length === 0">
        NO RESULTS FOUND
      </div>
      <v-list class="pt-0">
        <div v-for="item in searchResults" :key="`stock-search-${item.coCode}`">
          <v-list-item
            @click="toggleSelection(item, true)"
            :class="`${item.selected ? 'selected' : ''}`"
          >
            <v-list-item-content>
              <v-list-item-title v-html="item.name"></v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-scroll-x-transition>
                <v-icon
                  v-if="item.selected"
                  color="error"
                  @click.stop.prevent="toggleSelection(item, false)"
                >
                  mdi-close-octagon-outline
                </v-icon>
              </v-scroll-x-transition>
            </v-list-item-icon>
          </v-list-item>
          <v-divider></v-divider>
        </div>
      </v-list>
      <v-dialog v-model="openForm" persistent width="400px">
        <v-form ref="form">
          <v-card>
            <v-card-title primary-title> Save My Stock List </v-card-title>
            <v-card-text>
              <v-row no-gutters>
                <v-col :cols="12">
                  <v-text-field
                    outlined
                    dense
                    label="Name"
                    v-model="newIns.name"
                    required
                    :rules="nameRules"
                    hide-details
                  ></v-text-field>
                </v-col>
                <!-- <v-col :cols="12">
                  <v-textarea
                    label="Description"
                    auto-grow
                    outlined
                    rows="1"
                    row-height="15"
                    v-model="newIns.description"
                    hide-details
                  ></v-textarea>
                </v-col> -->
                <!-- <v-col :cols="12">
                  <v-text-field
                    outlined
                    dense
                    label="Priority"
                    v-model.number="newIns.ordinal"
                    required
                    hide-details
                  ></v-text-field>
                </v-col> -->

                <!-- <v-col :cols="12">
                  <v-switch
                    v-model="newIns.preSelect"
                    label="Auto Select"
                    color="primary"
                    hint="(Automatically Select the option on page load)"
                    persistent-hint
                  ></v-switch>
                </v-col> -->
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pr-4">
              <v-spacer></v-spacer>
              <v-btn outlined small color="primary" @click="saveCb()">
                <span>Save</span>
              </v-btn>
              <v-btn outlined text small color="error" @click="closeForm()"
                >Close</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="justify-center">
      <v-btn outlined text small color="error" @click="remove()" v-if="cbId"
        >Delete List</v-btn
      >
      <v-btn
        outlined
        text
        small
        color="primary"
        @click="update()"
        :disabled="!selectedCount"
        v-if="cbId"
        >
          <span v-if="cb.refId === 'stock_universe_tmp'">Load</span>
          <span v-else> Update  </span>
        </v-btn
      >
      <v-btn
        outlined
        text
        small
        color="primary"
        @click="save(false)"
        :disabled="!selectedCount"
        v-else-if="!editMode"
        >Save & Load</v-btn
      >
      <v-btn
        outlined
        text
        small
        color="primary"
        @click="save(true)"
        :disabled="!selectedCount"
        v-if="!editMode"
        >Load</v-btn
      >
      <v-btn
        outlined
        text
        small
        color="primary"
        @click="reset()"
        :disabled="!selectedCount"
        >Reset</v-btn
      >
      <v-btn outlined text small color="error" @click="openSearch(false)"
        >close</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<style>
mark {
  background: #ffc;
  color: #222;
}
.selected {
  background-color: #fbf8e9;
}
</style>

<script>
export default {
  name: "StockUniverse",
  props: {
    ogId: { type: String, required: true },
    codes: { type: String },
    open: { type: Boolean },
    cbId: { type: String },
    cb: { type: Object },
    editMode: Boolean,
  },
  data: () => ({
    openForm: false,
    query: "",
    loading: true,
    results: [],
    selectedItems: [],
    showSelected: false,
    newIns: { name: "", description: "", preSelect: false },
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 20) || "Name must be less than 20 characters",
    ],
  }),
  methods: {
    openSearch(status) {
      this.$emit("update:open", status);
    },
    search(query) {
      if (!query || query.length < 3) {
        return;
      }
      this.loading = true;
      this.reload = false;
      this.showSelected = false;
      let url = `/searchStocks?query=${query}`;
      this.$http.get(url).then((res) => {
        this.results = res.body;
      });
    },
    reset() {
      this.query = "";
      this.results = [];
      this.selectedItems = [];
      this.newIns = { name: "", description: "", preSelect: false };
      if (this.codes) {
        this.showSelected = true;
        let url = `/stocks?query=${this.codes}`;
        this.$http.get(url).then((res) => {
          this.selectedItems = res.body;
          this.selectedItems.forEach((item) => {
            item.selected = true;
          });
        });
      }
    },
    toggleSelection(stock, selected) {
      stock.selected = selected;
      let index = -1;
      this.selectedItems.some((item, idx) => {
        if (stock.coCode === item.coCode) {
          index = idx;
          return true;
        }
      });
      if (index > -1) {
        if (!stock.selected) {
          this.selectedItems.splice(index, 1);
        }
      } else if (stock.selected) {
        this.selectedItems.push(stock);
      }
    },
    saveCb(tmp) {
      let req = {
        ogId: this.ogId,
        name: this.newIns.name,
        description: this.newIns.description,
        preSelect: this.newIns.preSelect,
        codes: "|",
        ordinal: this.newIns.ordinal,
        tmp,
      };
      this.selectedItems.forEach((item) => {
        req.codes += `${item.coCode}|`;
      });
      if (tmp) {
        req.refId = "stock_universe_tmp";
        if (this.editMode) {
          this.$emit("update", req);
        } else {
          this.$emit("appendOgs", req);
        }
        this.closeForm();
        this.openSearch(false);
        return;
      }
      let v = this.$refs.form.validate();
      if (!v) return;
      this.$root.$loader.start();
      let api;
      if (this.cb && this.cb.refId) {
        req.refId = this.cb.refId;
        api = this.$http.put("/stockUniverse", req);
      } else {
        api = this.$http.post("/stockUniverse", req);
      }

      api
        .then((res) => {
          req.refId = res.body.refId;
          if (this.editMode) {
            this.$emit("update", req);
          } else {
            this.$emit("appendOgs", req);
          }
          this.closeForm();
          this.openSearch(false);
        })
        .catch((e) => {
          alert(e.body.message);
        })
        .finally(() => {
          this.$root.$loader.stop();
        });
    },
    save(tmp) {
      if (tmp) {
        this.newIns = {
          name: "Current Set",
          description: "",
          preSelect: true,
        };
        this.saveCb(true);
        return;
      }
      let lock = !this.$store.getters.isPremiumUser;
      if (lock) {
        this.$root.$subscribe.open();
        return;
      }
      this.openForm = true;
    },
    closeForm() {
      this.openForm = false;
      this.newIns = { name: "", description: "", preSelect: false };
    },
    update() {
      this.newIns = { name: this.cb.name, preSelect: this.cb.selected };
      let tmp = this.cb.refId === "stock_universe_tmp";
      console.log({ tmp });
      this.save(tmp);
    },
    remove() {
      let url = `/stockUniverse/${this.cbId}`;
      this.$http.delete(url).then(() => {
        this.openSearch(false);
        this.$emit("removeCb", { cbId: this.cbId });
      });
    },
  },
  watch: {
    open: {
      immediate: true,
      handler(n) {
        if (n) this.reset();
      },
    },
  },
  computed: {
    searchResults() {
      let matches = [];
      if (this.showSelected) {
        matches = this.selectedItems;
        return matches;
      }
      const regex = new RegExp(this.query, "gi");
      let selectedTxt = "|";
      this.selectedItems.forEach((item) => {
        selectedTxt += `${item.coCode}|`;
      });
      this.results.forEach((res) => {
        if (selectedTxt.indexOf(`|${res.coCode}|`) > -1) {
          res.selected = true;
        }
        if (this.query) {
          res.name = res.name.replace(
            regex,
            (match) => `<mark>${match}</mark>`
          );
        }
        matches.push(res);
      });
      return matches;
    },
    selectedCount() {
      return this.selectedItems.length | 0;
    },
  },
};
</script>